module.exports = ":root{--lui-tag-text-color:#272d37;--lui-tag-text-color-hover:var(--lui-tag-text-color);--lui-tag-text-color-focus:var(--lui-tag-text-color);--lui-tag-text-color-disabled:var(--lui-tag-text-color);--lui-tag-background-color:hsla(0,0%,100%,.6);--lui-tag-background-color-hover:hsla(0,0%,100%,.7);--lui-tag-background-color-focus:hsla(0,0%,100%,.8);--lui-tag-background-color-disabled:rgba(15,22,33,.8);--lui-tag-remove-icon-color:var(--lui-tag-text-color);--lui-tag-remove-icon-color-hover:var(--lui-tag-remove-icon-color)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tag/theme/lui-tag.global.scss
// module id = 350
// module chunks = 0 1 23